import { render, staticRenderFns } from "./code-lock.vue?vue&type=template&id=0afd1f34&scoped=true&"
import script from "./code-lock.vue?vue&type=script&lang=js&"
export * from "./code-lock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afd1f34",
  null
  
)

export default component.exports